import { NavBar } from './NavBar';

export type { TypeNavBarProps } from './types';
export default NavBar;
